// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer';

import './array';
import './element';
import './event';
import './math';
import './number';
import './object';
import './string';

// Object

/**
 * This is a polyfill for window.scrollTo and
 * a couple other working draft native scrolling methods.
 */
smoothscroll.polyfill();
